import { eventBus } from '@/main'

let loader = null
let fields = null
export const doms_ids = [
  199, // Guadeloupe
  213, // Martinique
  202, // Guyane
  228, // Réunion
  214, // Mayotte
  236, // Saint-Pierre-et-Miquelon
  231, // Saint-Barthélemy
  234, // Saint-Martin
  252, // Wallis et Futuna
  227, // Polynésie française
  221, // Nouvelle-Calédonie
  246, // Terres australes françaises
]

export const FRANCE_COUNTRY_ID = 6
export const SWITZERLAND_COUNTRY_ID = 160

// SIRET français : 14 chiffres, ex. 83788238000012
export const isValidFrenchSiret = value =>
  /^[0-9]{14}$/.test(String(value || '').replace(/\s+/g, ''))

// SIREN français : 9 chiffres, ex. 837882380
export const isValidFrenchSiren = value =>
  /^[0-9]{9}$/.test(String(value || '').replace(/\s+/g, ''))

// IDE suisse (identifiant d'entreprise) : "CHE" + 9 chiffres, ex. CHE-116.281.452
export const isValidSwissIDE = value =>
  /^CHE[0-9]{9}$/.test(String(value || '').toUpperCase().replace(/[\s.-]/g, ''))

export const isUserHomeInSwitzerland = user => {
  if (user && user.company) {
    return Number(user.company.country_id) === SWITZERLAND_COUNTRY_ID
  }
  return !!(user && user.home && Number(user.home.country) === SWITZERLAND_COUNTRY_ID)
}

export const STATE_REQUIRED_COUNTRY_IDS = [2, 46, 121]

export const isStateRequiredCountry = countryId =>
  STATE_REQUIRED_COUNTRY_IDS.includes(Number(countryId))

export const STATE_REQUIRED_COUNTRY_CODES = ['US', 'CA', 'MX']

export const isStateRequiredCountryCode = countryCode =>
  STATE_REQUIRED_COUNTRY_CODES.includes(String(countryCode || '').toUpperCase())

export const fieldsCountrySelect = fields => {
  if (!fields || !fields.country) return []

  const doms = []
  let fr = null
  const others = []

  for (const country of fields.country) {
    if (country.id === 6/* fr id */) {
      fr = { ...country }
      fr.text += ' métropolitaine'
    } else if (doms_ids.includes(country.id)) {
      doms.push(country)
    } else {
      others.push(country)
    }
  }
  others.unshift(fr, {
    text: 'France d\'outre-mer',
    children: doms,
  })
  return others
}

export const optionFields = {
  data: () => ({
    fields: false,
  }),
  methods: {
    isStateRequiredCountry(countryId) {
      return isStateRequiredCountry(countryId)
    },
    isSwissHome(user = this.user) {
      return isUserHomeInSwitzerland(user)
    },
    getAllFields() {
      if (!loader) {
        loader = this.$http.get('/api/options/').then(
          res => fields = res.data,
          err => console.error('Failed to load options', err),
        )
      }

      loader.then(() => {
        this.fields = fields
        eventBus.$emit('optionFields', fields)
      })
    },
    getFieldItems(fieldname, isSelect = 0, altfieldfname = '', aucun = '') {
      eventBus.$on('optionFields', (data) => {
        if (aucun != '') {
          data[fieldname].unshift({ id: 0, text: aucun })
        }

        if (altfieldfname != '') {
          eventBus.$emit('fieldItem', [altfieldfname, data[fieldname], isSelect])
        } else {
          eventBus.$emit('fieldItem', [fieldname, data[fieldname], isSelect])
        }
      })
    },
    getFieldName(fieldId, fieldname) {
      if (this.fields && this.fields[fieldname]) {
        for (const value of this.fields[fieldname]) {
          if (value.id == fieldId) {
            // Special case for DOM TOM countries
            if (fieldname === 'country' && doms_ids.includes(value.id)) {
              return 'France'
            }

            return value.text
          }
        }
      }
      return ''
    },
  },
  computed: {
    fieldsCountrySelect() {
      return fieldsCountrySelect(this.fields)
    },
  },
  created() {
    this.getAllFields()
  },
}
